import { toast } from "components/ui/use-toast";
import { useExtractorPdfState } from "../ducks/filter/hooks/state/state";
import { useExtractorPdfActions } from "../ducks/filter/hooks/actions/actions";
import { useUploadPdfExtractorIcmsMutation } from "@/services/tax/extracaopdf.icms";
import { downloadFromBlob } from "@/utils/download-blob";
import { useState } from "react";
import { InputMultiPdfUpload } from "components/input-file-upload";
import { ExtractionFooterActions } from "./extraction.footeractions";
import { ACCEPT_TYPE, MAX_FILE, MAX_FILE_SIZE_BYTES, PDF_MIME_TYPE } from "../constants/const";
import { MESSAGES } from "../utils/message";

export default function FileExtractorPdfIcmsUpload() {
  const { files } = useExtractorPdfState();
  const { setFiles } = useExtractorPdfActions();
  const [uploadPdfExtractorIcms, { isLoading }] = useUploadPdfExtractorIcmsMutation();
  const [lastBlob, setLastBlob] = useState<Blob | null>(null);

  const handleValidationIssues = (issues: { message: string; fileName?: string }[]) => {
    issues.slice(0, 3).forEach((i) =>
      toast({
        variant: "destructive",
        description: i.fileName ? `${i.fileName}: ${i.message}` : i.message,
      })
    );
    if (issues.length > 3) {
      toast({
        variant: "destructive",
        description: `+${issues.length - 3} outras validações.`,
      });
    }
  };

  const handleUpload = async () => {
    if (!files.length) return;
    try {
      const formData = new FormData();
      files.forEach((f) => formData.append("files", f));

      const zipBlob = await uploadPdfExtractorIcms({ body: formData }).unwrap();
      const fileName = `extracao_${Date.now()}.zip`;

      downloadFromBlob(zipBlob, fileName);
      setLastBlob(zipBlob);

      toast(MESSAGES.CREATE.SUCCESS);
    } catch (e) {
      console.error(e);
      toast(MESSAGES.CREATE.ERROR);
    }
  };

  return (
    <InputMultiPdfUpload
      files={files}
      onChange={setFiles}
      onClear={() => setFiles([])}
      disabled={isLoading}
      constraints={{
        maxFiles: MAX_FILE,
        maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
        acceptMime: [PDF_MIME_TYPE],
        acceptExt: [ACCEPT_TYPE],
      }}
      onValidationError={handleValidationIssues}
      footer={
        <ExtractionFooterActions
          hasFiles={!!files.length}
          isLoading={isLoading}
          onStart={handleUpload}
          lastBlob={lastBlob}
          onDownloadAgain={() => downloadFromBlob(lastBlob!, `extracao_${Date.now()}.zip`)}
        />
      }
    />
  );
}
